
export function FAQ(props){

    return(
        <div className="ui container">
            <p> Hello im the FAQ Page</p>
        </div>
    )
}